import React from "react";

import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { Box, Button, Card, CardContent, Typography } from "@mui/material";

import CloudProvidersIcons from "../../Common/CloudProvidersIcons";
import { type CloudProviderTag } from "../../types";

type Props = {
  cloudTag: CloudProviderTag;
  title: string;
  description: string;
  insightsNum: number;
  buttonText: string;
  onButtonClick: () => void;
};

const ProviderCard: React.FC<Props> = ({ cloudTag, title, description, insightsNum, buttonText, onButtonClick }) => (
  <Card>
    <CardContent
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        height: "100%",
        "&:last-child": {
          paddingBottom: 2,
        },
      }}
    >
      <Box>
        <Box mb={1}>
          <CloudProvidersIcons cloudTags={[cloudTag]} style={{ height: 24 }} />
        </Box>
        <Typography fontSize={14} fontWeight={500}>
          {title}
        </Typography>
        <Typography fontSize={14} fontWeight={500} color="error.main">
          {insightsNum} insights
        </Typography>
        <Typography variant="body2" mt={2}>
          {description}
        </Typography>
      </Box>
      <Box>
        <Button
          variant="outlined"
          endIcon={<OpenInNewIcon />}
          sx={{ mt: 2, pt: 0.3, pb: 0.3, pl: 1, pr: 1 }}
          onClick={onButtonClick}
        >
          <Typography fontSize={13} fontWeight={500}>
            {buttonText}
          </Typography>
        </Button>
      </Box>
    </CardContent>
  </Card>
);

export default ProviderCard;
